import React, { useEffect, useState } from "react";
import Header from "./Header";
import axios from "axios";
import { toast } from "react-toastify";
import { color } from "framer-motion";

function UpdateBankDetails() {
  let dealer_id = localStorage.getItem("dealer_id");
  let server_url = localStorage.getItem("server_url");
  const [bankDetails, setBankDetails] = useState([]);

  useEffect(() => {
    getBankDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getBankDetails = async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);
      const res = await axios.post(`${server_url}bank_details.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.status === "1") {
        setBankDetails(res.data.result);
      } else {
        setBankDetails([]);
        // toast.warning(res.data.error);
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    }
  };

  return (
    <div className="page-content" style={{ background: "#ffffff", minHeight: "100vh" }}>
      <Header />

      <div className="container mt-3">
        {bankDetails.length === 0 ? (
          <div className="text-center mt-5">
            <h5 className="text-muted" style={{ color: "#666666" }}>No Bank Details Available</h5>
          </div>
        ) : (
          bankDetails.map((bank, index) => (
            <div className="card card-style mb-3" key={index} style={{color:"#000000",background:"#ffffff", border: "1px solid #e5e5e5", boxShadow: "0 4px 15px rgba(0,0,0,0.05)"}}>
              <div className="content text-center">
                {/* UPI QR Image */}
                {bank.upi_qr_image && (
                  <img
                    src={bank.upi_qr_image}
                    className="img-fluid rounded mb-3"
                    style={{ maxHeight: "300px", width: "100%",  objectFit: "contain" }}
                    alt="UPI QR Code"
                  />
                )}

                {/* Bank Details */}
                <div className="text-start" style={{ padding: "0 15px" }}>
                    <span className=" font-15" style={{color:"#666666", display: "block", marginBottom: "4px"}}>Makarba Depo</span>
                    <h6 className="font-15 fw-bold mb-0" style={{color:"#000000", marginBottom: "16px"}}>{bank.bank_details_of}</h6>


                    <span className=" font-15" style={{color:"#666666", display: "block", marginBottom: "4px"}}>Bank Name</span>
                    <h6 className="font-15 fw-bold mb-0" style={{color:"#000000", marginBottom: "16px"}}>{bank.bank_name}</h6>


                    <span className="text-muted font-15" style={{color:"#666666", display: "block", marginBottom: "4px"}}>Branch Name</span>
                    <h6 className="font-15 fw-bold mb-0" style={{color:"#000000", marginBottom: "16px"}}>{bank.bank_branch}</h6>


                    <span className="text-muted font-15" style={{color:"#666666", display: "block", marginBottom: "4px"}}>Account Number</span>
                    <h6 className="font-15 fw-bold mb-0" style={{color:"#000000", marginBottom: "16px"}}>{bank.bank_account_number}</h6>


                    <span className="text-muted font-15" style={{color:"#666666", display: "block", marginBottom: "4px"}}>IFSC Code</span>
                    <h6 className="font-15 fw-bold mb-0" style={{color:"#000000", marginBottom: "0"}}>{bank.bank_ifsc_code}</h6>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default UpdateBankDetails;